module.exports = __webpack_public_path__ + "static/media/Background1.f306b714.jpg";